<div id="dvamxprint"></div>

<div class="row">
  <div class="col-md-12">
    <div class="col-md-6 col-sm-6">
      <h3>{{ 'pages.cashoutPage.cashout' | translate }}</h3>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12" *ngIf="cashoutByCurrency.length > 0">
    <div class="col-md-6 col-sm-6">
      <button class="btn btn-primary" (click)="performChashOut()">{{ 'common.confirm' | translate }}</button>
    </div>
  </div>
</div>

<div *ngIf="cashoutByCurrency.length == 0" class="row table-row">
  <div class="responsive-table col-md-12">
    <div class="col-md-12">
      <table class="table table-striped ">
        <thead>
          <tr>
            <th><b>{{ 'pages.cashoutPage.receiptNumber' | translate }}</b></th>
            <th><b>{{ 'common.date' | translate }}</b></th>
            <th><b>{{ 'common.total' | translate }}</b></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div style="text-align:center">
        <h4>{{ 'pages.cashoutPage.noReceiptToChashout' | translate }}</h4>
      </div>
    </div>
  </div>
</div>

<div *ngFor="let rec of cashoutByCurrency">
  <div class="row table-row">
    <div class="responsive-table col-md-12">
      <div class="col-md-12">
        <table class="table table-striped ">
          <thead>
            <tr>
              <th><b>{{ 'pages.cashoutPage.receiptNumber' | translate }}</b></th>
              <th><b>{{ 'common.date' | translate }}</b></th>
              <th><b>{{ 'common.total' | translate }}</b></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of rec.result; index as i">
              <td>{{item.Number}}</td>
              <td>{{item.CreatedOn}}</td>
              <td>{{item.TotalAmount?.Value}} {{item.TotalAmount?.Code}}</td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="rec.result.length == 0" style="text-align:center">
          <h4>{{ 'pages.cashoutPage.noReceiptToChashout' | translate }}</h4>
        </div>
      </div>
    </div>
  </div>

  <nav class="nav-pagination">
    <ul class="pagination">
      <li *ngIf="!(rec.pagesContainer <=1) && (rec.pagger != 0)"><button class="btn "
          (click)="prevPage(rec.currency)"><span class="armx-icon armx-left-dir"></span></button></li>
      <li *ngIf="!(rec.pagesContainer <=1) && rec.pagger >= 3"><button class="btn "
          (click)="getSearchPage(0, rec.currency)">1</button> ..</li>
      <li *ngFor="let a of rec.pagesContainer; let index = index">
        <button
          *ngIf="((index == rec.pagger) || (rec.pagger <= index + 5) && (index > rec.pagger - 3 && index < rec.pagger + 5) ) && !(rec.pagesContainer <=1)"
          (click)="getSearchPage(index, rec.currency)"
          class="btn  {{index == rec.pagger ? 'active' : 'no'}}">{{index+1}}</button>
        {{index < rec.pagger && index>= rec.pagger+5 ? '.' : ''}}
          <button class="btn " *ngIf="index == rec.pagesContainer.length"
            (click)="getSearchPage(rec.pagger, rec.currency)">{{rec.pagger + 1
            }}</button>
      </li>
      <li *ngIf="!(rec.pagesContainer <=1) && (rec.pagger <= rec.pagesContainer.length-6)">
        ..
        <button class="btn  {{rec.pagesContainer.length == rec.pagger ? 'active' : 'no'}}"
          (click)="getSearchPage(rec.pagesContainer.length-1, rec.currency)">{{rec.pagesContainer.length}}</button>
        <button class="btn" (click)="nextPage(rec.currency)"><a><span
              class="armx-icon armx-right-dir"></span></a></button>
      </li>
    </ul>
  </nav>
</div>